import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { Department, StorehouseOutput } from 'core/http/project';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as StorehousesActions from './storehouses.actions';

export interface StorehousesState extends CompletedEntityState<StorehouseOutput> {
  departments: Department[];
}

const adapter: EntityAdapter<StorehouseOutput> = createEntityAdapter<StorehouseOutput>();

export const initialStorehousesState = adapter.getInitialState<StorehousesState>({
  ...initialCompletedEntityState,
  departments: new Array<Department>(),
});

const reducer = createReducer(
  initialStorehousesState,
  on(StorehousesActions.saveStorehouses, (state, payload) => adapter.setAll(payload.storehouses, state)),
  on(StorehousesActions.markStorehouseLoaded, state => ({ ...state, loaded: true })),
  on(StorehousesActions.addStorehouseInStore, (state, storehouse) => adapter.addOne(storehouse, state)),
  on(StorehousesActions.updateStorehouseInStore, (state, { update }) => adapter.updateOne(update, state)),
  on(StorehousesActions.removeStorehouseFromStore, (state, { id }) => adapter.removeOne(id, state)),
  on(StorehousesActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(StorehousesActions.setError, (state, { value }) => ({ ...state, error: value })),
  on(StorehousesActions.saveDepartments, (state, { departments }) => ({ ...state, departments })),
);

export function storehousesReducer(state: StorehousesState | undefined, action: Action): StorehousesState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectTotal,
} = adapter.getSelectors();
